// extracted by mini-css-extract-plugin
export default {"Body":"_Body--a4cP_","BodyContainer":"_BodyContainer--eAnkb","BodyText":"_BodyText--G7JLA","WarningIcon":"_WarningIcon--t_UKm","RemoveButton":"_RemoveButton--yoEsF"};